import React, { useState } from 'react'
import { useNavigate, useLocation } from "react-router-dom"

import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import { RiGlobalFill } from "react-icons/ri"
import { HiMenuAlt1, HiShoppingCart } from "react-icons/hi"
import { AiOutlineClose, AiFillCaretRight, AiOutlineCaretRight } from "react-icons/ai"
import { MdExpandMore } from "react-icons/md"

import { useSelector } from "react-redux"

import Logo from "../../Assets/logo.png"

import "./NavBar.scss"





const NavBar = () => {
  const Navigate = useNavigate()
  const location = useLocation()

  let CarsData = useSelector((state) => state.CarsData)
  let CartData = useSelector((state) => state.CartData)

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [changeNavbar, setChangeNavBar] = useState(false);
  const changingNavBar = () => {
    if (window.scrollY >= 80) {
      setChangeNavBar(true);
    } else {
      setChangeNavBar(false);
    }
  };
  window.addEventListener("scroll", changingNavBar);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const closeSideBar = () => {
    setState({ ...state, right: false })
  }

  const goTo = (link) => {
    closeSideBar()
    Navigate(link)
  }

  return (
    <>
      <div style={changeNavbar || location.pathname == "/cart" ? { backgroundColor: "black" } : {}} className="navbar_container">
        <div className="navbar_box">
          <div className="left">
            <div className="link" onClick={() => goTo("about")}> About Flux </div>
            <div className="link car_list_box"> Design Yours
              <div className="cars_list">
                {
                  CarsData && CarsData.length >= 1 ?
                    CarsData.map((data) => {
                      return (
                        <>
                          <div className="car" onClick={() => goTo(`/design?id=${data._id}`)}>
                            {/* <img src={data.paintsWheels[0].wheels[0].carImg} alt="" /> */}
                            <p>{data.name}</p>
                          </div>
                        </>
                      )
                    })
                    :
                    <>
                    </>
                }
              </div>
            </div>
            <div className="link" onClick={() => goTo("contact")}> CONTACT </div>
          </div>
          <div className="middle">
            <div className="logo" onClick={() => goTo("/")}>
              <img src={Logo} alt="" />
            </div>
          </div>
          <div className="right">
            {
              (location.pathname == "/store" || location.pathname == "/cart") && 
              <div className="icon cart" onClick={() => goTo("/cart")}> {CartData && CartData.length >= 1 && <div className="cart_count">{CartData.length}</div>} <HiShoppingCart /> </div>
            }
            <div className="link" onClick={() => goTo("/store")}>Store</div>
            <div className="update" onClick={() => goTo("/subscribe")}>Stay Update</div>
            <div className="icon" onClick={toggleDrawer("right", true)}><HiMenuAlt1 /></div>
          </div>
        </div>

        <SwipeableDrawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
        >
          <Box
            sx={{ width: 350, backgroundColor: "black", height: "-webkit-fill-available", overflowY: "scroll", padding: "1rem 0" }}
            role="presentation"
            onKeyDown={toggleDrawer("right", false)}
          >
            <div className="side_bar_container">
              <div className="line" style={{ justifyContent: "end" }}>
                <span onClick={toggleDrawer("right", false)}><AiOutlineClose /></span>
              </div>
              <div className="line1">
                <div className="name" onClick={() => goTo("/")}>Home</div>
                <div className="name" onClick={() => goTo("/subscribe")}>Stay Update</div>
              </div>
              <div className="line">
                <div className="name" onClick={() => goTo("/about")}>About Flux</div>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <div className="line accordion_line">
                <Accordion>
                  <AccordionSummary
                    expandIcon={<MdExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    {/* <Typography>Accordion 1</Typography> */}
                    <div className="name">Design Yours</div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="cars_list">
                      {
                        CarsData && CarsData.length >= 1 ?
                          CarsData.map((data) => {
                            return (
                              <>
                                <div className="car" onClick={() => goTo(`/design?id=${data._id}`)}>
                                  {/* <img src={data.paintsWheels[0].wheels[0].carImg} alt="" /> */}
                                  <p>{data.name}</p>
                                </div>
                              </>
                            )
                          })
                          :
                          <>
                          </>
                      }
                    </div>
                  </AccordionDetails>
                </Accordion>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <div className="line">
                <div className="name" onClick={() => goTo("/store")}>Store</div>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <br />
              <div className="line">
                <div className="name" onClick={() => goTo("about")}>More About Flux</div>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              {/* <div className="line" onClick={() => goTo("/about")} >
                <div className="name">Company</div>
                <div className="icon"><AiFillCaretRight /></div>
              </div> */}
              <br />
              <div className="line">
                <div className="name" onClick={() => goTo("/contact")} >Contact Us</div>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <div className="line">
                <div className="name" onClick={() => goTo("/privacy")}>Privacy policy</div>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <div className="line">
                <div className="name" onClick={() => goTo("/terms")}>Terms of Use</div>
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <div className="line">
                {/* <div className="name">Warranty</div> */}
                {/* <div className="icon"><AiFillCaretRight /></div> */}
              </div>
              <br />
              <div className="socials">
                <svg
                  width={21}
                  height={21}
                  viewBox="0 0 21 21"
                  xmlns="http://www.w3.org/2000/svg"
                  focusable="false"
                >
                  <g fill="currentColor" fillRule="evenodd">
                    <path d="M16.06 3.689a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5M10.5 13.973a3.473 3.473 0 11.003-6.947 3.473 3.473 0 01-.003 6.947m0-8.822a5.35 5.35 0 100 10.698 5.349 5.349 0 100-10.698m8.48 9.558c-.047 1.016-.217 1.567-.36 1.934-.19.487-.414.834-.779 1.198a3.185 3.185 0 01-1.198.778c-.366.144-.918.313-1.934.36-1.098.05-1.427.061-4.21.061-2.78 0-3.11-.011-4.208-.061-1.016-.047-1.567-.216-1.934-.36a3.201 3.201 0 01-1.198-.778 3.227 3.227 0 01-.78-1.198c-.142-.367-.312-.918-.358-1.934-.05-1.098-.06-1.428-.06-4.208 0-2.783.01-3.112.06-4.21.046-1.016.216-1.567.359-1.934.188-.488.414-.834.779-1.198.365-.365.712-.59 1.198-.78.367-.143.918-.312 1.934-.358 1.098-.05 1.427-.06 4.209-.06 2.782 0 3.111.01 4.209.06 1.016.046 1.568.215 1.934.359a3.2 3.2 0 011.198.779c.365.364.59.71.78 1.198.142.367.312.918.359 1.934.05 1.098.06 1.427.06 4.21 0 2.78-.01 3.11-.06 4.208m1.875-8.503c-.051-1.11-.227-1.867-.484-2.53a5.096 5.096 0 00-1.203-1.844A5.11 5.11 0 0017.324.63c-.664-.257-1.42-.435-2.53-.483C13.684.095 13.329.083 10.5.083c-2.828 0-3.184.013-4.294.064-1.11.049-1.867.226-2.53.483a5.115 5.115 0 00-1.844 1.202A5.097 5.097 0 00.63 3.677c-.257.662-.433 1.42-.483 2.529-.052 1.11-.064 1.466-.064 4.295 0 2.827.013 3.183.064 4.293.05 1.109.226 1.867.483 2.529a5.118 5.118 0 001.202 1.845c.58.58 1.16.935 1.845 1.201.662.258 1.42.435 2.529.485 1.11.05 1.466.063 4.294.063 2.829 0 3.184-.012 4.294-.063 1.11-.05 1.866-.227 2.53-.485a5.104 5.104 0 001.844-1.2 5.12 5.12 0 001.203-1.846c.257-.662.433-1.42.484-2.529.049-1.11.061-1.466.061-4.293 0-2.83-.012-3.186-.061-4.295" />
                  </g>
                </svg>

                <svg
                  width={22}
                  height={20}
                  viewBox="0 0 22 20"
                  xmlns="http://www.w3.org/2000/svg"
                  focusable="false"
                >
                  <path
                    d="M6.919 19.166c8.302 0 12.842-7.052 12.842-13.168 0-.2-.004-.4-.013-.598A9.281 9.281 0 0022 3.003a8.862 8.862 0 01-2.592.73 4.632 4.632 0 001.985-2.561 8.907 8.907 0 01-2.866 1.123A4.457 4.457 0 0015.232.833c-2.493 0-4.514 2.073-4.514 4.628 0 .363.04.716.117 1.055-3.751-.193-7.078-2.035-9.305-4.835a4.705 4.705 0 00-.61 2.326c0 1.606.797 3.023 2.009 3.852A4.398 4.398 0 01.884 7.28v.06c0 2.241 1.555 4.112 3.62 4.537a4.451 4.451 0 01-2.038.079c.575 1.839 2.24 3.177 4.217 3.214A8.912 8.912 0 010 17.088a12.55 12.55 0 006.919 2.08"
                    fill="currentColor"
                    fillRule="nonzero"
                  />
                </svg>

                <svg
                  width={24}
                  height={16}
                  viewBox="0 0 24 16"
                  xmlns="http://www.w3.org/2000/svg"
                  focusable="false"
                >
                  <path
                    d="M12.237-.001c1.294.005 7.466.05 9.138.477 1.033.262 1.845 1.036 2.123 2.02.5 1.783.5 5.503.5 5.503v.011c0 .22-.016 3.763-.5 5.49-.278.983-1.09 1.758-2.123 2.021-1.712.437-8.14.474-9.222.477h-.31c-1.082-.003-7.51-.04-9.22-.477C1.588 15.258.775 14.483.5 13.5.045 11.885.002 8.68-.002 8.092v-.187C.002 7.318.045 4.111.5 2.496.776 1.512 1.588.738 2.622.476 4.294.05 10.465.004 11.76 0zm-2.639 4.57v6.857l6.235-3.428-6.235-3.43z"
                    fill="currentColor"
                    fillRule="evenodd"
                  />
                </svg>

                <svg
                  className="socialButton button ButtonSocialComponent-module--button--KGpXI"
                  width={22}
                  height={22}
                  viewBox="0 0 22 22"
                  xmlns="http://www.w3.org/2000/svg"
                  focusable="false"
                >
                  <g fill="currentColor" fillRule="evenodd">
                    <path d="M21.667 10.9c0-6.02-4.85-10.9-10.834-10.9C4.851 0 0 4.88 0 10.9c0 5.439 3.962 9.95 9.141 10.767V14.05h-2.75V10.9h2.75V8.497c0-2.731 1.618-4.24 4.092-4.24 1.185 0 2.424.213 2.424.213v2.682h-1.366c-1.345 0-1.764.84-1.764 1.702V10.9h3.004l-.48 3.15h-2.524v7.618c5.179-.817 9.14-5.328 9.14-10.768" />
                  </g>
                </svg>
              </div>
            </div>
          </Box>
        </SwipeableDrawer>
      </div>
    </>
  )
}

export default NavBar